import { render, staticRenderFns } from "./ComisionShowData.vue?vue&type=template&id=878411be"
import script from "./ComisionShowData.vue?vue&type=script&lang=js"
export * from "./ComisionShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports